import React from 'react';
import { usePageContent } from '../hooks/usePageContent';
import { usePageTitle } from '../hooks/usePageTitle';

export default function Contact() {
    const { content, loading, error } = usePageContent('contact');

    usePageTitle('Contact');

    if (loading) return <div className="container-narrow py-20">Loading...</div>;
    if (error || !content) return <div className="container-narrow py-20 text-red-600">{error || 'No content found.'}</div>;

    const channels = content.channels || [];

    return (
        <>
            <section className="container-narrow pt-12 md:pt-28 pb-8">
                <p className="eyebrow mb-6">Contact</p>
                <h1 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tightest text-fg">
                    {content.h1Title}
                </h1>
                <p className="mt-6 max-w-prose text-[16px] text-fg-muted leading-relaxed">
                    {content.h1Description}
                </p>
            </section>

            <section className="container-narrow pb-14 md:pb-24">
                <ul className="divide-y divide-line border-y border-line">
                    {channels.map((c) => (
                        <li key={c.label}>
                            <a
                                href={c.href}
                                target={c.href.startsWith('http') ? '_blank' : undefined}
                                rel={c.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                                className="group grid grid-cols-12 gap-4 py-7 items-baseline transition-colors hover:bg-elevated -mx-4 px-4 rounded-md"
                            >
                                <div className="col-span-12 md:col-span-3">
                                    <p className="eyebrow">{c.label}</p>
                                </div>
                                <div className="col-span-12 md:col-span-9">
                                    <p className="font-display text-[20px] md:text-[24px] tracking-tight text-fg group-hover:text-accent transition-colors break-all">
                                        {c.value}
                                    </p>
                                    <p className="mt-2 text-[14px] text-fg-muted">{c.note}</p>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>

                <p className="mt-12 text-[13px] text-fg-soft">
                    {content.closingText}
                </p>
            </section>
        </>
    );
}
